import { signal } from '@preact/signals';

export const scrolling = signal(false);
